import React, { useState, useEffect } from "react";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
// import { getItem } from "../../../utils/localStorage";
import { addFAQURL, getFAQsURL } from "../../../utils/urls";

const FAQ = () => {
    const [faqs, setFaqs] = useState([]);
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");

    const handleAddFAQ = async (e) => {
        e.preventDefault();
        try {
            // const facilityId = await getItem("selectedFacilityId");
            const response = await makeRequest2(`${addFAQURL}`, "POST", {
                // facilityId,
                question,
                answer,
            });

            if (response.success) {
                toastify("FAQ added successfully!", "success");
                // Ensure response.data is an object, not the whole list
                setFaqs((prev) => [...prev, response.data]);
                setQuestion("");
                setAnswer("");
            } else {
                throw new Error(response.error || "Failed to add FAQ");
            }
        } catch (err) {
            toastify(err.message, "error");
        }
    };

    const getFAQs = async () => {
        try {
            // const facilityId = await getItem("selectedFacilityId");
            const response = await makeRequest2(`${getFAQsURL}`, "GET");

            console.log("Response:", response);

            if (response.success) {
                const data = Array.isArray(response.data.faqs) ? response.data.faqs : [];
                setFaqs(data);
            } else {
                throw new Error(response.error || "Failed to fetch FAQs");
            }
        } catch (err) {
            toastify(err.message, "error");
            setFaqs([]); // Prevents map errors if something goes wrong
        }
    };

    useEffect(() => {
        getFAQs();
    }, []);

    return (
        <div className="card border-0 shadow-sm">
            <div className="card-header bg-light">
                <h5 className="mb-0 text-primary">
                    <i className="fas fa-question-circle me-2"></i> Frequently Asked Questions
                </h5>
            </div>

            <div className="card-body">
                {/* Add FAQ Form */}
                <div className="card mb-4">
                    <div className="card-header bg-light">
                        <h6 className="mb-0">
                            <i className="fas fa-plus-circle me-2 text-success"></i>Add New FAQ
                        </h6>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleAddFAQ}>
                            <div className="mb-3">
                                <label className="form-label fw-semibold">Question</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your question"
                                    value={question}
                                    onChange={(e) => setQuestion(e.target.value)}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-semibold">Answer</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    placeholder="Enter the answer"
                                    value={answer}
                                    onChange={(e) => setAnswer(e.target.value)}
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-primary">
                                <i className="fas fa-save me-2"></i> Add FAQ
                            </button>
                        </form>
                    </div>
                </div>

                {/* FAQ List */}
                <div className="card">
                    <div className="card-header bg-light">
                        <h6 className="mb-0">
                            <i className="fas fa-list me-2 text-info"></i>FAQ List
                        </h6>
                    </div>
                    <div className="card-body">
                        {Array.isArray(faqs) && faqs.length > 0 ? (
                            <div className="accordion" id="faqAccordion">
                                {faqs.map((faq, index) => (
                                    <div className="accordion-item mb-3" key={index}>
                                        <h2 className="accordion-header" id={`heading-${index}`}>
                                            <button
                                                className={`accordion-button ${index !== 0 ? "collapsed" : ""
                                                    }`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse-${index}`}
                                                aria-expanded={index === 0 ? "true" : "false"}
                                                aria-controls={`collapse-${index}`}
                                            >
                                                {faq.question}
                                            </button>
                                        </h2>
                                        <div
                                            id={`collapse-${index}`}
                                            className={`accordion-collapse collapse ${index === 0 ? "show" : ""
                                                }`}
                                            aria-labelledby={`heading-${index}`}
                                            data-bs-parent="#faqAccordion"
                                        >
                                            <div className="accordion-body">{faq.answer}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-muted mb-0">No FAQs available yet.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;

